// Tiny value tree for extract results and parse blocks: leaf rows are buttons
// so a click (or hover) can reveal the citation / block box in the viewer.
import { cn } from '@/lib/utils'

export function JsonTree({
  value,
  path = '',
  onLeaf,
  onHover,
  active,
  leafId = (p) => p,
}: {
  value: unknown
  path?: string
  onLeaf?: (path: string) => void
  onHover?: (path: string | undefined) => void
  active?: string
  /** Maps a JSON path to the id the viewer knows (default: the path itself). */
  leafId?: (path: string) => string
}) {
  if (value && typeof value === 'object') {
    const entries = Array.isArray(value)
      ? value.map((v, i) => [String(i), v] as const)
      : Object.entries(value)
    return (
      <ul className={cn('flex flex-col gap-0.5', path && 'ml-3 border-l border-border pl-2')}>
        {entries.map(([k, v]) => {
          const p = path ? `${path}.${k}` : k
          const leaf = !(v && typeof v === 'object')
          const id = leafId(p)
          return (
            <li key={k}>
              {leaf ? (
                <button
                  type="button"
                  onClick={() => onLeaf?.(id)}
                  onMouseEnter={() => onHover?.(id)}
                  onMouseLeave={() => onHover?.(undefined)}
                  className={cn(
                    'flex w-full gap-2 rounded-sm px-1 py-0.5 text-left font-mono text-xs hover:bg-muted focus-visible:ring-2 focus-visible:ring-primary focus-visible:outline-none',
                    active === id && 'bg-primary/10',
                  )}
                >
                  <span className="text-muted-foreground">{k}:</span>
                  <span className="min-w-0 truncate">
                    {v === null ? 'null' : typeof v === 'string' ? `"${v}"` : String(v)}
                  </span>
                </button>
              ) : (
                <>
                  <span className="px-1 font-mono text-xs text-muted-foreground">{k}</span>
                  <JsonTree
                    value={v}
                    path={p}
                    onLeaf={onLeaf}
                    onHover={onHover}
                    active={active}
                    leafId={leafId}
                  />
                </>
              )}
            </li>
          )
        })}
      </ul>
    )
  }
  return <span className="font-mono text-xs">{String(value)}</span>
}
